export default __webpack_public_path__ + "static/media/Section3BG.5b06ac43.png";